// eslint-disable-next-line
export const VendorAbi = require('../../../artifacts/contracts/' + 'KhizaTokenVendor' + '.sol/' + 'KhizaTokenVendor' + '.json').abi;
// eslint-disable-next-line
export const ERC20Abi = require('../../../artifacts/contracts/' + 'AcceptedToken' + '.sol/' + 'AcceptedToken' + '.json').abi;

export default { VendorAbi, ERC20Abi }